export default "__VITE_ASSET__DVnFy4LB__"